import "./src/css/style.css";
import 'lazysizes'

import kwesforms from 'kwesforms';
export const onInitialClientRender = () => {
  kwesforms.init();
}
